import { Button } from '@ds';
import { MdOutlineClear } from 'react-icons/md';
import { FilterDropdown } from '@ui';
import { LogisticProviderListFilters } from '@/api/apis/facilities';
import { UseFiltersType } from '@/hooks/useFilters';
import { useSearchableList } from '@/hooks/useSearchableList';
import { useLogisticProviderFilters } from '../hooks/useLogisticProviderFilters';

type LogisticProviderFiltersProps = UseFiltersType<LogisticProviderListFilters>;

export const LogisticProviderFilters = ({
  filters,
  hasFilters,
  updateFilters,
  clearFilters,
}: LogisticProviderFiltersProps) => {
  const {
    serviceRegionItems,
    countriesDropdownItems,
    countriesSelectedKeys,
    statesSelectList,
    handleRegionChange,
    handleCountriesChange,
  } = useLogisticProviderFilters({ filters, updateFilters });
  const selectedRegion = serviceRegionItems.find((item) => item.value === filters.serviceRegionIds);

  const { list: filteredCountries, setSearchValue: onCountriesSearch } = useSearchableList(countriesDropdownItems, [
    'name',
    'value',
  ]);
  const { list: filteredStates, setSearchValue: onStatesSearch } = useSearchableList(statesSelectList, [
    'name',
    'value',
  ]);

  return (
    <div className="flex gap-7 items-center">
      <FilterDropdown
        title={selectedRegion?.name || 'Service Region'}
        items={serviceRegionItems}
        selectedKeys={filters.serviceRegionIds ? [filters.serviceRegionIds] : []}
        mode="single"
        onSelectedKeysChange={handleRegionChange}
        showCounter={false}
      />
      <FilterDropdown
        title="Country Coverage"
        items={filteredCountries}
        selectedKeys={countriesSelectedKeys}
        mode="multiple"
        onSearchValue={onCountriesSearch}
        onSelectedKeysChange={handleCountriesChange}
      />
      {filters.countries.length > 0 && statesSelectList.length > 0 && (
        <FilterDropdown
          title="State"
          items={filteredStates}
          selectedKeys={filters.states}
          mode="multiple"
          onSearchValue={onStatesSearch}
          onSelectedKeysChange={(values) => updateFilters(values, 'states')}
        />
      )}
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onPress={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
